'use strict';

var ArrayBufferViewCore = require('../internals/array-buffer-view-core');

var $findLast = require('../internals/array-iteration-from-last').findLast;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.findLast` method
// https://github.com/tc39/proposal-array-find-from-last

exportTypedArrayMethod('findLast', function findLast(predicate
/* , thisArg */
) {
  return $findLast(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});